import { useCallback, useRef } from "react";
import useActiveState from "./useActiveState";
import general from "../general";

/** 同一时刻只发一次 hasNewReply，多 tab / 多组件共用一次请求 */
let inflight = null;

const useFeedbackReply = () => {
  const [feedbackNewReply, setFeedbackNewReply] =
    useActiveState("feedbackNewReply");

  // useActiveState 的 setter 每帧都是新函数，不能放进 useCallback 依赖，否则 refresh 引用一直变
  const setReplyRef = useRef(setFeedbackNewReply);
  setReplyRef.current = setFeedbackNewReply;

  const refreshFeedbackNewReply = useCallback(async () => {
    if (!general.isLogin()) {
      setReplyRef.current("");
      return false;
    }

    if (inflight) {
      return inflight;
    }

    inflight = (async () => {
      try {
        const { data: resData } = await general.axios.post(
          "/v3/base/feedback/hasNewReply",
        );
        const { status, data } = resData;

        if (!status?.succeed) {
          return false;
        }

        const hasNewReply = !!data?.has_new_reply;
        setReplyRef.current(hasNewReply ? "1" : "");
        return hasNewReply;
      } catch (error) {
        console.error(error);
        return false;
      } finally {
        inflight = null;
      }
    })();

    return inflight;
  }, []);

  return {
    hasNewReply: feedbackNewReply === "1",
    refreshFeedbackNewReply,
    setFeedbackNewReply,
  };
};

export default useFeedbackReply;
